import { useDishListBySlugQuery } from '~/libs/gql/queries/dish_lists/dishListBySlugQuery.generated';

type UseDishBySlugDataArgs = {
  slug: string | null | undefined
}

export const useDishListBySlugData = ({ slug }: UseDishBySlugDataArgs) => {
  const query = useDishListBySlugQuery({
    skip: !slug,
    variables: {
      pagination: {
        limit: 48,
        offset: 0,
        sortBy: 'popsCount',
        sortDir: 'desc',
      },
      slug: slug ?? '',
    },
  });
  return query;
};
